import React from 'react';
import { Edit } from 'react-admin';
import PositionRateSettingsForm from '../shared/position-rate-settings-form/PositionRateSettingsForm';
import { getTransform } from '../rateSettingsTransform';

const MarketPositionRateSettingEdit = () => {
  return (
    <Edit
      mutationMode="pessimistic"
      transform={getTransform(
        [
          'market_id',
          'margin_percent_1099_guardrail',
          'payout_rate_percent_1099_guardrail',
          'incremental_margin_percent_1099',
          'margin_percent_w2_guardrail',
          'payout_rate_percent_w2_guardrail',
          'incremental_margin_percent_w2',
          'margin_percent_w2_travel_guardrail',
          'payout_rate_percent_w2_travel_guardrail',
        ],
        'market_position_rate_setting',
      )}
    >
      <PositionRateSettingsForm settingsField="market_position_rate_setting" />
    </Edit>
  );
};

export default MarketPositionRateSettingEdit;
